import { FDV_URL, IDUSUARIO, USERNAME, customAxios } from '../constants';
import { FETCH_AUTORIZACIONES, FETCH_AUTORIZACIONES_USUARIOS, FETCH_USUARIOS_APROBADORES, PERMISOS_AUTORIZADOR } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchAutorizaciones(fdvID) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/autorizaciones`, config)
                  .then(({ data }) => evalAction(data, 'autorizaciones'))
                .catch(error => serverError(error, 'autorizaciones'));

  return {
    type: FETCH_AUTORIZACIONES,
    payload: request,
  };
}


export function fetchAutorizacionesUsuarios(numFichaVtaVeh, codCia, codProv, numPedidoVeh, codAutFichaVta) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
    params: {
      numFichaVtaVeh,
      codCia,
      codProv,
      numPedidoVeh,
      codAutFichaVta
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/autorizaciones-usuarios`, config)
                            .then(({ data }) => evalAction(data, 'autorizacionesUsuarios'))
                          .catch(error => serverError(error, 'autorizacionesUsuarios'));

  return {
    type: FETCH_AUTORIZACIONES_USUARIOS,
    payload: request,
  };
}

export function fetchUsuariosAprobadores(numFichaVtaVeh, codCia, codProv, numPedidoVeh, codAutFichaVta) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO
    },
    params: {
      codCia,
      codProv,
      numPedidoVeh,
      codAutFichaVta
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFichaVtaVeh}/aprobadores`, config)
                .then(({ data }) => evalAction(data, 'aprobadores'))
              .catch(error => serverError(error, 'aprobadores'));

  return {
    type: FETCH_USUARIOS_APROBADORES,
    payload: request,
  };
}

export function autorizarActividad(numFichaVtaVeh, codAutFichaVta, codCia, codProv, numPedidoVeh) {
  const config = {
    params: {
      codAprobFichaVtaAut: 'A',
      coUsuarioAut: USERNAME,
      codCia: codCia,
      codProv: codProv,
      numPedidoVeh: numPedidoVeh
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  return customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${numFichaVtaVeh}/autorizaciones/${codAutFichaVta}`, [], config)
                          .then(({ data }) => evalAction(data, 'autorizaciones'))
                        .catch(error => serverError(error, 'autorizaciones'))

}

export function validarUsuarioAutorizador(numFichaVtaVeh, codAutFichaVta, codCia, codProv, numPedidoVeh,desAutFichaVta) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO
    },
    params: {
      codCia,
      codProv,
      numPedidoVeh,
      desAutFichaVta
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFichaVtaVeh}/autorizaciones/${codAutFichaVta}/permisos`, config)
                            .then(({ data }) => evalAction(data, 'permisos'))
                          .catch(error => serverError(error, 'permisos'));

  return {
    type: PERMISOS_AUTORIZADOR,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Autorizaciones.js